import z from 'zod/v4'

export const languages = ['fi', 'en', 'sv'] as const

export const languageSchema = z
  .enum(languages)
  .describe('The language identifier. These are all languages which are supported by the app.')

export type LanguageType = z.infer<typeof languageSchema>

export const translatableFieldSchema = z.array(
  z.object({
    lang: languageSchema,
    text: z.string(),
  })
)

export type TranslatableField = z.infer<typeof translatableFieldSchema>

export function getTranslatedText(text: TranslatableField | string, lang: LanguageType) {
  if (typeof text === 'string') {
    return text
  }

  return text.find((t) => t.lang === lang)?.text
}
